import { isMozioBrand } from "../utils/white-label";
import { Header } from "./header";
import { MozioHeaderContainer } from "./mozio-header";
import type { User } from "@mozioinc/query";

type HeaderSwitchProps = {
  user?: User;
};

/** The redesigned nav shipped for Mozio hosts only (SNAV-14); partners keep the old header. */
export const HeaderSwitch = ({ user }: HeaderSwitchProps) => {
  if (!isMozioBrand()) {
    return <Header user={user} />;
  }

  return <MozioHeaderContainer user={user} />;
};
